export const LOAD_REQUESTS = 'LOAD_REQUESTS'
export const LOAD_CURRENT_REQUEST = 'LOAD_CURRENT_REQUEST'
export const LOAD_ACCOUNT_STATUS = 'LOAD_ACCOUNT_STATUS'
export const UPDATE_REQUEST_STATUS = 'UPDATE_REQUEST_STATUS'
export const LOAD_MERCHANT_REQUESTS = 'LOAD_MERCHANT_REQUESTS'
export const LOAD_MERCHANT_ACCOUNT_STATUS = 'LOAD_MERCHANT_ACCOUNT_STATUS'
export const LOAD_CURRENT_MERCHANT_REQUEST = 'LOAD_CURRENT_MERCHANT_REQUEST'